import DE_LANDING_PAGE_CONSTANTS from './de'
import EN_LANDING_PAGE_CONSTANTS from './en'
import FR_LANDING_PAGE_CONSTANTS from './fr'
import HU_LANDING_PAGE_CONSTANTS from './hu'
import { T_LANDING_PAGE_CONSTANTS } from './TYPES'

import { T_GENERIC_LANGUAGE_MAP } from '~/src/Constants/LANGUAGE'

import objectPathFactory from '~/src/Lib/objectPathFactory'

const LANDING_PAGE_CONSTANTS: T_GENERIC_LANGUAGE_MAP<T_LANDING_PAGE_CONSTANTS> =
  {
    hu: HU_LANDING_PAGE_CONSTANTS,
    en: EN_LANDING_PAGE_CONSTANTS,
    fr: FR_LANDING_PAGE_CONSTANTS,
    de: DE_LANDING_PAGE_CONSTANTS
  }

export default LANDING_PAGE_CONSTANTS

export const LANDING_PAGE_CONSTANTS_PATH =
  objectPathFactory<T_LANDING_PAGE_CONSTANTS>()
